import React from "react";
import { Link } from "react-router-dom";

const domains = [
  { icon: "fa-chess", title: "Consulting & Strategy", desc: "Pitch, decks, term sheets, intros." },
  { icon: "fa-scale-balanced", title: "Legal & Compliance", desc: "Contracts, IP, MSME, regulatory." },
  { icon: "fa-calculator", title: "Finance & Taxation", desc: "GST, ITR, books, cap-tables." },
  { icon: "fa-hand-holding-dollar", title: "Funding & Investor Relations", desc: "Brand, performance & content." },
  { icon: "fa-bullhorn", title: "Digital Marketing & Promotions", desc: "Channels, marketplaces, ops." },
  { icon: "fa-microchip", title: "Technology & Product", desc: "DGFT, IEC, global GTM." },
  { icon: "fa-truck-fast", title: "Operations & Supply Chain", desc: "Market entry & scaling plays." },
  { icon: "fa-users-gear", title: "HR & Talent Acquisition", desc: "Process, vendors, supply chain." },
  { icon: "fa-newspaper", title: "PR & Media Relations", desc: "Data, audits, ISO, SOC2." },
  { icon: "fa-globe", title: "International Trade & Import-Export", desc: "MVPs, CTO advisory, stack." },
  { icon: "fa-handshake", title: "MSME & Govt Liaison", desc: "Channel, BD, alliances." },
  { icon: "fa-rocket", title: "Startup & Innovation Cell", desc: "Loans, invoice finance, NBFC." },
  { icon: "fa-folder-open", title: "Content Management", desc: "Identity, packaging, web." },
  { icon: "fa-person-running", title: "Zumba & Fitness", desc: "Channels, marketplaces, ops." },
  { icon: "fa-brain", title: "Mind Motivation & Life Coaching", desc: "PLI, plants, lean ops." },
  { icon: "fa-building", title: "Real Estate & Infrastructure", desc: "Reports, BRSR, impact." },
  { icon: "fa-industry", title: "Manufacturing & Industrial Advisory", desc: "Leadership & mindset." },
  { icon: "fa-palette", title: "Branding & Marketing Strategy", desc: "M&A, valuation, exits." },
  { icon: "fa-venus", title: "Women Entrepreneurship Cell", desc: "Startup India, DPIIT, grants." },
  { icon: "fa-earth-asia", title: "NRI / Global Bengali Desk", desc: "TAM, customer, surveys." },
];

const metricCards = [
  {
    accent: "linear-gradient(90deg,#6366f1,#818cf8)",
    iconBg: "rgba(99,102,241,0.15)",
    iconColor: "#818cf8",
    icon: "fa-users",
    num: "25+",
    label: "Vetted experts",
  },
  {
    accent: "linear-gradient(90deg,#14b8a6,#2dd4bf)",
    iconBg: "rgba(20,184,166,0.15)",
    iconColor: "#2dd4bf",
    icon: "fa-layer-group",
    num: "15+",
    label: "Startups incubated",
  },
  {
    accent: "linear-gradient(90deg,#e879f9,#d946ef)",
    iconBg: "rgba(217,70,239,0.15)",
    iconColor: "#e879f9",
    icon: "fa-handshake",
    num: "100+",
    label: "Entrepreneurs Engaged",
  },
  {
    accent: "linear-gradient(90deg,#38bdf8,#0ea5e9)",
    iconBg: "rgba(14,165,233,0.15)",
    iconColor: "#38bdf8",
    icon: "fa-arrow-trend-up",
    num: "10+",
    label: "Startup funding processed",
  },
];

const ExpertDomains = () => {
  return (
    <section className="py-20 sm:py-28 relative" data-testid="expert-domains-section">
      {/* ── Responsive styles injected once ── */}
      <style>{`
        @media (min-width: 768px) {
          [data-testid="flagship-banner"] {
            flex-direction: row !important;
            align-items: center !important;
          }
          .flagship-left,
          .flagship-right {
            flex: 1 1 0 !important;
          }
        }
        @media (max-width: 767px) {
          [data-testid="flagship-banner"] {
            flex-direction: column !important;
            align-items: stretch !important;
            padding: 1.75rem 1.5rem !important;
          }
          .flagship-left,
          .flagship-right {
            width: 100% !important;
          }
          .metric-grid {
            grid-template-columns: 1fr 1fr !important;
          }
        }

        .apply-funding-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          background: transparent;
          border: 1.5px solid rgba(255, 255, 255, 0.32);
          border-radius: 9999px;
          padding: 0.75rem 1.5rem;
          color: #fff;
          font-size: 13.5px;
          font-weight: 500;
          cursor: pointer;
          width: fit-content;
          font-family: inherit;
          position: relative;
          overflow: hidden;
          text-decoration: none;
          transition:
            border-color 0.4s ease,
            color 0.4s ease,
            box-shadow 0.4s ease,
            transform 0.3s ease;
          z-index: 0;
        }

        .apply-funding-btn::before {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: 9999px;
          background: linear-gradient(135deg, #6366f1 0%, #14b8a6 100%);
          opacity: 0;
          transition: opacity 0.4s ease;
          z-index: -1;
        }

        .apply-funding-btn:hover::before {
          opacity: 1;
        }

        .apply-funding-btn:hover {
          border-color: transparent;
          box-shadow: 0 0 22px rgba(99, 102, 241, 0.55), 0 0 8px rgba(20, 184, 166, 0.3);
          transform: translateY(-2px);
        }

        .apply-funding-btn:active {
          transform: translateY(0px);
          box-shadow: 0 0 10px rgba(99, 102, 241, 0.3);
        }

        /* Touch devices — no hover, so show gradient always */
        @media (hover: none) {
          .apply-funding-btn {
            border-color: transparent;
            box-shadow: 0 0 18px rgba(99, 102, 241, 0.4);
          }
          .apply-funding-btn::before {
            opacity: 1;
          }
        }

        .apply-funding-btn .btn-arrow {
          display: inline-block;
          transition: transform 0.35s ease;
        }

        .apply-funding-btn:hover .btn-arrow {
          transform: translateX(4px);
        }
      `}</style>

      <div className="section">

        {/* ── FLAGSHIP BANNER — dark navy ── */}
        <div
          data-testid="flagship-banner"
          style={{
            background: "#0A0F1E",
            borderRadius: "2rem",
            padding: "clamp(1.5rem, 4vw, 3rem) clamp(1.25rem, 4vw, 3.5rem)",
            display: "flex",
            flexDirection: "column",   /* mobile-first: stacked */
            alignItems: "stretch",
            gap: "2rem",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Glow TL */}
          <div style={{
            position: "absolute", top: "-6rem", left: "-6rem",
            width: "24rem", height: "24rem", borderRadius: "50%",
            background: "radial-gradient(circle,rgba(99,102,241,0.18) 0%,transparent 70%)",
            pointerEvents: "none",
          }} />
          {/* Glow BR */}
          <div style={{
            position: "absolute", bottom: "-6rem", right: "18rem",
            width: "20rem", height: "20rem", borderRadius: "50%",
            background: "radial-gradient(circle,rgba(20,184,166,0.11) 0%,transparent 70%)",
            pointerEvents: "none",
          }} />

          {/* LEFT — text + buttons */}
          <div
            className="flagship-left"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1.1rem",
              position: "relative",
              zIndex: 1,
            }}
          >
            {/* Badge */}
            <div style={{
              display: "inline-flex", alignItems: "center", gap: "0.5rem",
              background: "rgba(99,102,241,0.13)",
              border: "1px solid rgba(99,102,241,0.28)",
              borderRadius: "50px", padding: "6px 16px", width: "fit-content",
            }}>
              <div style={{
                width: 8, height: 8, borderRadius: "50%",
                background: "#a78bfa", boxShadow: "0 0 7px #a78bfa99",
              }} />
              <span style={{
                fontSize: "10.5px", fontWeight: 700,
                letterSpacing: "0.13em", color: "#c4b5fd", textTransform: "uppercase",
              }}>
                Flagship Domain
              </span>
            </div>

            {/* Headline */}
            <div style={{
  fontSize: "clamp(1.75rem, 3.5vw, 2.6rem)",
  fontWeight: 700,
  lineHeight: 1.1,
  color: "#fff",
  margin: 0,
  fontFamily: "'Poppins', 'Inter', sans-serif",
  letterSpacing: "-0.01em",
}}>
  Funding &amp;{" "}
  <span style={{
    background: "linear-gradient(135deg,#6366f1 0%,#14b8a6 100%)",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  }}>
    Investor
  </span>
  <br />
  <span style={{
    background: "linear-gradient(135deg,#6366f1 0%,#14b8a6 100%)",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  }}>
    Relations
  </span>
</div>

            {/* Body text */}
            <p style={{
              fontSize: "14.5px", color: "rgba(255,255,255,0.75)",
              lineHeight: 1.68, maxWidth: 350, margin: 0,
            }}>
              IBH provides funding support across all stages — serving startups,
              MSMEs, and established enterprises alike, without limitation!
            </p>

            {/* Buttons */}
            <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem", marginTop: "0.25rem" }}>
              <a
                href="https://forms.gle/gpodVKZY3oJ6RxBS6"
                target="_blank"
                rel="noopener noreferrer"
                className="apply-funding-btn"
              >
                Apply for Funding <span className="btn-arrow">→</span>
              </a>
            </div>
          </div>

          {/* RIGHT — hero card + 2×2 grid */}
          <div
            className="flagship-right"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.75rem",
              position: "relative",
              zIndex: 1,
            }}
          >
            {/* Hero card */}
            <div style={{
              background: "linear-gradient(145deg, #1a1f4e 0%, #141836 60%, #0f1228 100%)",
              border: "1px solid rgba(99,102,241,0.4)",
              borderRadius: "16px", padding: "1.5rem 1.6rem",
              position: "relative", overflow: "hidden",
              boxShadow: "0 8px 32px rgba(10,10,30,0.6)",
            }}>
              <div style={{
                position: "absolute", top: "-2rem", right: "-2rem",
                width: "12rem", height: "12rem", borderRadius: "50%",
                background: "radial-gradient(circle, rgba(99,102,241,0.2) 0%, transparent 70%)",
                pointerEvents: "none",
              }} />

              <div style={{
                display: "flex", alignItems: "center",
                justifyContent: "space-between", marginBottom: "1rem",
                position: "relative", zIndex: 1,
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: "0.55rem" }}>
                  <div style={{
                    width: 28, height: 28, borderRadius: 7,
                    background: "rgba(99,102,241,0.25)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 13, color: "#a5b4fc", fontWeight: 700,
                  }}>₹</div>
                  <span style={{
                    fontSize: "10px", fontWeight: 700, letterSpacing: "0.13em",
                    color: "rgba(255,255,255,0.5)", textTransform: "uppercase",
                  }}>
                    Funds Raised
                  </span>
                </div>
                <div style={{
                  background: "#2d2f6b",
                  border: "1px solid rgba(99,102,241,0.45)",
                  borderRadius: "0.45rem", padding: "4px 11px",
                  fontSize: "11px", fontWeight: 700,
                  color: "#a5b4fc", letterSpacing: "0.03em",
                  whiteSpace: "nowrap",
                }}>
                  FY 26–27 Q1
                </div>
              </div>

              <div style={{
                fontSize: "clamp(2rem, 4.5vw, 3.2rem)",
                fontWeight: 800, color: "#fff", lineHeight: 1,
                marginBottom: "0.5rem", letterSpacing: "-0.01em",
                position: "relative", zIndex: 1,
              }}>
                ₹11.5 Cr+
              </div>

              <div style={{
                fontSize: "12.5px", color: "rgba(255,255,255,0.6)",
                position: "relative", zIndex: 1,
              }}>
                Across portfolio companies
              </div>
            </div>

            {/* 2×2 metric cards */}
            <div
              className="metric-grid"
              style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.75rem" }}
            >
              {metricCards.map((m) => (
                <div
                  key={m.label}
                  style={{
                    background: "linear-gradient(145deg,rgba(20,26,52,0.97) 0%,rgba(13,17,38,0.99) 100%)",
                    border: "1px solid rgba(255,255,255,0.07)",
                    borderRadius: "16px",
                    padding: "1.25rem",
                    position: "relative", overflow: "hidden",
                  }}
                >
                  {/* colored top accent */}
                  <div style={{
                    position: "absolute", top: 0, left: 0, right: 0,
                    height: 2, background: m.accent,
                  }} />
                  {/* icon */}
                  <div style={{
                    width: 30, height: 30, borderRadius: 8,
                    background: m.iconBg,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    marginBottom: "0.75rem", fontSize: 13,
                  }}>
                    <i className={`fa-solid ${m.icon}`} style={{ color: m.iconColor }}></i>
                  </div>
                  <div style={{
                    fontSize: "1.5rem",
                    fontWeight: 700,
                    color: "#fff", lineHeight: 1, marginBottom: 5,
                  }}>
                    {m.num}
                  </div>
                  <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)", lineHeight: 1.4 }}>
                    {m.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* ── END FLAGSHIP BANNER ── */}

        {/* Section header */}
        <div className="mt-16 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div className="max-w-2xl">
            <h3 className="font-display text-3xl sm:text-4xl font-bold text-slate-900">
              20 Expert Domains.
              <br />
              <span className="gradient-text">One IBH membership.</span>
            </h3>
            <p className="mt-3 text-slate-600">
              Tap into deep specialists across every functional area Indian businesses need to grow.
            </p>
          </div>
          <Link
  to="/experts"
  className="btn-secondary self-start lg:self-end ibh-meet-team-btn"
  data-testid="domains-view-all"
>
  Meet Our Team
  <i className="fa-solid fa-arrow-right text-xs"></i>
</Link>
        </div>

        {/* 20-domain grid */}
        <div
          className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4"
          data-testid="domain-grid"
        >
          {domains.map((d, i) => (
  <div
    key={d.title}
    className="group relative rounded-2xl bg-white border border-slate-200/70 p-5 card-hover"
    data-testid={`domain-card-${i}`}
  >
    <div className="h-10 w-10 rounded-xl bg-slate-900 text-white flex items-center justify-center group-hover:bg-ibh-green transition-colors">
      <i className={`fa-solid ${d.icon}`}></i>
    </div>
    <p className="mt-4 font-display font-bold text-slate-900 text-[15px] leading-tight">
      {d.title}
    </p>
    <p className="mt-1.5 text-xs text-slate-500 leading-relaxed">{d.desc}</p>
  </div>
))}
        </div>

      </div>
    </section>
  );
};

export default ExpertDomains;